<div class="app-page-title">
    <div class="page-title-wrapper">
        <div class="page-title-heading">
            <div class="page-title-icon">
                <i class="pe-7s-box2 icon-gradient bg-mean-fruit">
                </i>
            </div>
            <div>Commande
                <div class="page-title-subheading">Détail de la commande.
                </div>
            </div>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-md-12">
        <div class="main-card mb-3 card">
            <div class="tab-content" id="tab-content">
                <div class="main-card mb-12 card">
                    <div class="card-body">
                        <div id="commande" #commande>
                            <div class="row">
                                <div class="col-md-7">
                                    <div class="text space">
                                        <h4><strong>Commande</strong></h4>
                                    </div>
                                </div>
                                <div class="col-md-5 text-md-right">
                                    <h4><strong>#{{cmd.ref_facture_cmd}}</strong></h4>
                                    <!-- <qrcode print [width]="150" usesvg="true" [elementType]="'svg'" [qrdata]="cmd._id"
                            [errorCorrectionLevel]="'M'"></qrcode> -->
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-7">
                                    <div class="text space">
                                        <qrcode print [width]="150" usesvg="true" [elementType]="'svg'"
                                            [qrdata]="cmd.qr_code" [errorCorrectionLevel]="'M'">
                                        </qrcode>
                                    </div>
                                </div>
                                <div class="col-md-5 text-md-right">
                                    <strong>Client:</strong><br />
                                    {{cmd.user_destination?.nom_destination}}<br />
                                    {{cmd.user_destination?.numtel_destination}}<br />
                                    {{cmd.user_destination?.adresse_destination}}<br />
                                    {{cmd.destination_cmd}}<br /><br />

                                    <strong>Date de commande:</strong><br />
                                    {{cmd.date_creation_cmd | date:'dd/MM/yyyy'}}<br />
                                    <div class="badge badge-{{statusCmds[cmd.etat_cmd]?.color}}">
                                        {{statusCmds[cmd.etat_cmd]?.label}}
                                    </div>
                                </div>
                            </div>

                            <div class="clearfix"></div>

                            <div class="row">
                                <div class="col-md-12">
                                    <!-- <div class="main-card mb-3 card"> -->
                                    <div class="section-title" *ngIf="cmd.products?.length > 0">
                                        Détails de la commande
                                    </div>

                                    <div class="table-responsive">
                                        <div class="budget-price justify-content-center"
                                            *ngIf="cmd.products?.length === 0">
                                            <h5 class="text-center">Aucune produit affecté dans la
                                                commande
                                            </h5>
                                        </div>
                                        <table
                                            class="align-middle mb-0 table table-borderless table-striped table-hover"
                                            *ngIf="cmd.products?.length > 0">
                                            <thead>
                                                <tr>
                                                    <th class="text-center">#</th>
                                                    <th class="text-left">Nom du produit</th>
                                                    <th class="text-center">Prix unitaire</th>
                                                    <th class="text-center">Quantite</th>
                                                    <th class="text-center">Montant</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let prd of cmd.products, let index = index">
                                                    <td class="text-center text-muted">#{{index+1}}</td>
                                                    <td class="text">{{prd.nom_prod}}<br>
                                                        <b *ngIf="cmd.isExchange==true">Echange ({{prd.quantite}} article(s))</b>
                                                    </td>
                                                    <td class="text-center">{{prd.prix_unitaire}} DT
                                                    </td>
                                                    <td class="text-center">{{prd.quantite}}</td>
                                                    <td class="text-center">
                                                        {{prd.quantite*prd.prix_unitaire}} DT</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <!-- </div> -->
                                </div>
                            </div>

                            <div class="clearfix"></div>

                            <div class="row mt-4">
                                <div class="col-lg-8">
                                    <div class="section-title">Mode de livraison</div>
                                    <p class="section-lead">
                                        À domicile
                                        <br />→ {{cmd.destination_cmd}}
                                    </p>
                                </div>
                                <div class="col-lg-4 text-right">
                                    <div class="invoice-detail-item">
                                        <div class="invoice-detail-name">Prix des article(s):
                                            {{cmd.total_ca_cmd |
                                            number:'0.3'}} TND</div>
                                        <div class="invoice-detail-name">Frais de livraison:
                                            {{cmd.frais_livraison | number:'0.3'}} TND
                                        </div>
                                        <div class="invoice-detail-value">Montant total:
                                            {{cmd.total_ca_cmd+cmd.frais_livraison |
                                            number:'0.3'}} TND
                                        </div>
                                        <!-- <div class="invoice-detail-value">Poids: {{cmd.weight_cmd}} g</div> -->
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="d-block text-center card-footer">
                        <!-- <button class="mr-2 btn-icon btn-icon-only btn btn-outline-danger"><i
                                class="pe-7s-trash btn-icon-wrapper"> </i></button> -->

                        <!-- <button class="btn-wide btn btn-success">Save</button> -->
                        <button class="btn btn-danger float-left" [routerLink]="[ '/commandes']"><i
                                class="metismenu-icon pe-7s-back"></i> Retour</button>

                        <button class="btn btn-warning float-right text-white"
                            (click)="goToNewTab(cmd._id, '/facture')"><i
                                class="metismenu-icon pe-7s-print text-white"></i> Imprimer</button>
                        <button *ngIf="cmd.etat_cmd=='delivered' && cmd.payed_cmd==false" class="btn btn-success float-right" [routerLink]="[ '/exchange-cmd']"
                            [queryParams]="{ cmd: cmd._id }"><i class="metismenu-icon pe-7s-back"></i>
                            Echange</button>
                        <!-- <button class="btn btn-warning float-right" (click)="generatePDF()"><i
                                class="metismenu-icon pe-7s-print"></i> Imprimer</button> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="row">
    <div class="col-md-12">
        <div class="main-card mb-3 card">
            <div class="card-header">Commentaires</div>
            <div class="card-body">
                <div class="chat-container">
                    <ul class="chat-box chatContainerScroll">
                        <!-- <li class="chat-left">
                            <div class="chat-avatar">
                                <img src="https://www.bootdey.com/img/Content/avatar/avatar3.png"
                                    alt="Retail Admin">
                                <div class="chat-name">Russell</div>
                            </div>
                            <div class="chat-text">Hello, I'm Russell.
                                <br>How can I help you today?
                            </div>
                            <div class="chat-hour">08:55 <span class="fa fa-check-circle"></span></div>
                        </li>
                        <li class="chat-right">
                            <div class="chat-hour">08:56 <span class="fa fa-check-circle"></span></div>
                            <div class="chat-text">Hi, Russell
                                <br> I need more information about Developer Plan.
                            </div>
                            <div class="chat-avatar">
                                <img src="https://www.bootdey.com/img/Content/avatar/avatar3.png"
                                    alt="Retail Admin">
                                <div class="chat-name">Sam</div>
                            </div>
                        </li>
                        <li class="chat-left">
                            <div class="chat-avatar">
                                <img src="https://www.bootdey.com/img/Content/avatar/avatar3.png"
                                    alt="Retail Admin">
                                <div class="chat-name">Russell</div>
                            </div>
                            <div class="chat-text">Are we meeting today?
                                <br>Project has been already finished and I have results to show you.
                            </div>
                            <div class="chat-hour">08:57 <span class="fa fa-check-circle"></span></div>
                        </li>
                        <li class="chat-right">
                            <div class="chat-hour">08:59 <span class="fa fa-check-circle"></span></div>
                            <div class="chat-text">Well I am not sure.
                                <br>I have results to show you.
                            </div>
                            <div class="chat-avatar">
                                <img src="https://www.bootdey.com/img/Content/avatar/avatar5.png"
                                    alt="Retail Admin">
                                <div class="chat-name">Joyse</div>
                            </div>
                        </li>
                        <li class="chat-left">
                            <div class="chat-avatar">
                                <img src="https://www.bootdey.com/img/Content/avatar/avatar3.png"
                                    alt="Retail Admin">
                                <div class="chat-name">Russell</div>
                            </div>
                            <div class="chat-text">The rest of the team is not here yet.
                                <br>Maybe in an hour or so?
                            </div>
                            <div class="chat-hour">08:57 <span class="fa fa-check-circle"></span></div>
                        </li> -->
                        <div *ngFor="let comment of cmd.comments, let index = index">

                            <li class="chat-right" *ngIf="comment.id_user == client._id">
                                <div class="chat-hour">{{comment.date_ajout | date:'d MMM y HH:mm'}}
                                    <span class="fa fa-check-circle"></span>
                                </div>
                                <div class="chat-text">{{comment.content}}</div>
                                <div class="chat-avatar">
                                    <!-- <img src="https://www.bootdey.com/img/Content/avatar/avatar4.png"
                                        alt="Retail Admin"> -->
                                    <ngx-avatar width="42" class="rounded-circle"
                                        name="{{comment?.name_user}}">
                                    </ngx-avatar>
                                    <div class="chat-name">{{comment.name_user}}</div>
                                </div>
                            </li>

                            <li class="chat-left" *ngIf="comment.id_user !== client?._id">
                                <div class="chat-avatar">
                                    <ngx-avatar width="42" class="rounded-circle"
                                        name="{{comment?.name_user}} ">
                                    </ngx-avatar>
                                    <div class="chat-name">{{comment.name_user}}</div>
                                </div>
                                <div class="chat-text">{{comment.content}}</div>
                                <div class="chat-hour">{{comment.date_ajout | date:'d MMM y HH:mm'}}
                                    <span class="fa fa-check-circle"></span>
                                </div>
                            </li>

                        </div>

                    </ul>
                    <div class="form-group mt-3 mb-0">
                        <form class="" action="" method="post" onsubmit="return false;"
                            (onsubmit)="addComment(comment);">
                            <div class="form-row">
                                <div class="col-md-1">
                                    <div class="position-relative form-group">
                                        <ngx-avatar width="42" class="rounded-circle"
                                            name="{{client?.prenom_client + ' ' + client?.nom_client}}">
                                        </ngx-avatar>
                                    </div>
                                    <!-- {{client?.prenom_client +" "+client?.nom_client}} -->
                                </div>
                                <div class="col-md-10">
                                    <div class="position-relative form-group">
                                        <textarea name="comment" id="comment" class="form-control"
                                            rows="2" placeholder="Ajouter un commentaire..." #comment
                                            ngModel></textarea>
                                    </div>
                                </div>
                                <div class="col-md-1">
                                    <div class="position-relative form-group">
                                        <button type="submit" (click)="addComment(comment)"
                                            class="form-control btn btn-success">Envoyer</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>

<div class="row">
    <div class="col-md-8">
        <div class="main-card mb-3 card">
            <div class="card-header">Détail de la commande "<strong>{{cmd.ref_facture_cmd}}</strong>"
                <div class="btn-actions-pane-right">
                    <div role="group" class="btn-group-sm btn-group">
                        <button type="button" id="PopoverCustomT-1"
                            class="btn btn-danger btn-sm">Details <i
                                class="metismenu-icon pe-7s-angle-right"></i></button>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <div class="table-responsive">
                    <table class="align-middle mb-0 table table-borderless table-striped table-hover">
                        <thead>
                            <tr>
                                <th>Status</th>
                                <th>Description</th>
                                <th>Date de l'action
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <!-- <td><a href="#"  class="font-weight-600">INV-87239</a></td> -->
                                <td>
                                    <div class="badge badge-warning">Créé</div>
                                </td>
                                <td class="font-weight-600">Par
                                    {{cmd?.user_destination?.nom_destination}}
                                </td>
                                <td>{{cmd.date_creation_cmd | date:'MMM d, y h:mm:ss a'}}</td>
                            </tr>
                            <tr *ngIf="cmd.pcollect_transport!=null">
                                <!-- <td><a href="#">INV-76824</a></td> -->
                                <td>
                                    <div class="badge badge-{{statusCmds['transporting_depot']?.color}}">
                                        {{statusCmds['transporting_depot'].label}}</div>
                                </td>
                                <td class="font-weight-600">Collecté par
                                    {{cmd.pcollect_transport?.transporter_id?.nom_prenom_tracking}}
                                </td>
                                <td>{{cmd.pcollect_transport?.date_accept | date:'MMM d, y h:mm:ss a'}}
                                </td>
                            </tr>
                            <tr *ngIf="cmd.to_governorate!=null">
                                <!-- <td><a href="#">INV-76824</a></td> -->
                                <td>
                                    <div class="badge badge-{{statusCmds['transporting_to']?.color}}">
                                        {{statusCmds['transporting_to'].label}}</div>
                                </td>
                                <td class="font-weight-600">Colis en cours de transport vers 
                                    "{{cmd.destination_cmd}}"
                                </td>
                                <td>{{cmd.to_governorate | date:'MMM d, y h:mm:ss a'}}
                                </td>
                            </tr>
                            <tr *ngIf="cmd.between_governorate!=null">
                                <!-- <td><a href="#">INV-76824</a></td> -->
                                <td>
                                    <div class="badge badge-{{statusCmds['transporting_between']?.color}}">
                                        {{statusCmds['transporting_between'].label}}</div>
                                </td>
                                <td class="font-weight-600">Colis en cours de transport entre 
                                    "{{cmd.destination_cmd}}"
                                </td>
                                <td>{{cmd.to_governorate | date:'MMM d, y h:mm:ss a'}}
                                </td>
                            </tr>
                            <tr *ngIf="cmd.transport_topcollect!=null">
                                <!-- <td><a href="#">INV-48574</a></td> -->
                                <td>
                                    <div class="badge badge-{{statusCmds['transporting']?.color}}">
                                        {{statusCmds['transporting'].label}}</div>
                                </td>
                                <td class="font-weight-600">Par
                                    {{cmd.transport_topcollect?.transporter_id?.nom_prenom_tracking}}
                                </td>
                                <td>{{cmd.transport_topcollect?.date_accept | date:'MMM d, y h:mm:ss
                                    a'}}
                                </td>
                            </tr>
                            <tr *ngIf="cmd.date_relivered_cmd!=null">
                                <!-- <td><a href="#">INV-48574</a></td> -->
                                <td>
                                    <div class="badge badge-{{statusCmds['delivered']?.color}}">
                                        {{statusCmds['delivered'].label}}</div>
                                </td>
                                <td class="font-weight-600">Commande livré au client
                                    "{{cmd.user_destination.nom_destination}}"</td>
                                <td>{{cmd.date_relivered_cmd | date:'MMM d, y h:mm:ss
                                    a'}}
                                </td>
                            </tr>
                            <tr *ngIf="cmd.payed_cmd==true">
                                <!-- <td><a href="#">INV-84990</a></td> -->
                                <td>
                                    <div class="badge badge-{{statusCmds['paied']?.color}}">
                                        {{statusCmds['paied'].label}}
                                    </div>
                                </td>
                                <td class="font-weight-600">Commande payé à l'expéditeur<br>
                                    "{{cmd.client_cmd.prenom_client}} {{cmd.client_cmd.nom_client}}"</td>
                                <td>{{cmd.date_payed_cmd | date:'MMM d, y h:mm:ss a'}}</td>
                            </tr>
                            <tr *ngIf="cmd.date_returned_cmd!=null">
                                <!-- <td><a href="#">INV-87320</a></td> -->
                                <td>
                                    <div class="badge badge-{{statusCmds['returned']?.color}}">
                                        {{statusCmds['returned'].label}}
                                    </div>
                                </td>
                                <td class="font-weight-600"
                                    *ngIf="cmd?.transport_affect[cmd?.transport_affect?.length-1]?.transporter_id==null">
                                    Par
                                    {{cmd?.transport_affect[cmd?.transport_affect?.length-2]?.transporter_id?.nom_prenom_tracking}}<br />{{cmd.msg_returned_cmd}}
                                </td>
                                <td class="font-weight-600"
                                    *ngIf="cmd?.transport_affect[cmd?.transport_affect?.length-1]?.transporter_id!=null">
                                    Par
                                    {{cmd?.transport_affect[cmd?.transport_affect?.length-1]?.transporter_id?.nom_prenom_tracking}}<br />{{cmd.msg_returned_cmd}}
                                </td>
                                <td>{{cmd.date_returned_cmd | date:'MMM d, y h:mm:ss a'}}</td>
                            </tr>
                            <!-- <tr>
                                <td class="text-center text-muted">#345</td>
                                <td>
                                    <div class="widget-content p-0">
                                        <div class="widget-content-wrapper">
                                            <div class="widget-content-left mr-3">
                                                <div class="widget-content-left">
                                                    <img width="40" class="rounded-circle"
                                                        src="assets/images/avatars/4.jpg" alt="">
                                                </div>
                                            </div>
                                            <div class="widget-content-left flex2">
                                                <div class="widget-heading">John Doe</div>
                                                <div class="widget-subheading opacity-7">Web Developer</div>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td class="text-center">Madrid</td>
                                <td class="text-center">
                                    <div class="badge badge-warning">Pending</div>
                                </td>
                                <td class="text-center">
                                    <button type="button" id="PopoverCustomT-1"
                                        class="btn btn-primary btn-sm">Details</button>
                                </td>
                            </tr>
                            <tr>
                                <td class="text-center text-muted">#347</td>
                                <td>
                                    <div class="widget-content p-0">
                                        <div class="widget-content-wrapper">
                                            <div class="widget-content-left mr-3">
                                                <div class="widget-content-left">
                                                    <img width="40" class="rounded-circle"
                                                        src="assets/images/avatars/3.jpg" alt="">
                                                </div>
                                            </div>
                                            <div class="widget-content-left flex2">
                                                <div class="widget-heading">Ruben Tillman</div>
                                                <div class="widget-subheading opacity-7">Etiam sit amet orci
                                                    eget</div>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td class="text-center">Berlin</td>
                                <td class="text-center">
                                    <div class="badge badge-success">Completed</div>
                                </td>
                                <td class="text-center">
                                    <button type="button" id="PopoverCustomT-2"
                                        class="btn btn-primary btn-sm">Details</button>
                                </td>
                            </tr>
                            <tr>
                                <td class="text-center text-muted">#321</td>
                                <td>
                                    <div class="widget-content p-0">
                                        <div class="widget-content-wrapper">
                                            <div class="widget-content-left mr-3">
                                                <div class="widget-content-left">
                                                    <img width="40" class="rounded-circle"
                                                        src="assets/images/avatars/2.jpg" alt="">
                                                </div>
                                            </div>
                                            <div class="widget-content-left flex2">
                                                <div class="widget-heading">Elliot Huber</div>
                                                <div class="widget-subheading opacity-7">Lorem ipsum dolor
                                                    sic</div>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td class="text-center">London</td>
                                <td class="text-center">
                                    <div class="badge badge-danger">In Progress</div>
                                </td>
                                <td class="text-center">
                                    <button type="button" id="PopoverCustomT-3"
                                        class="btn btn-primary btn-sm">Details</button>
                                </td>
                            </tr>
                            <tr>
                                <td class="text-center text-muted">#55</td>
                                <td>
                                    <div class="widget-content p-0">
                                        <div class="widget-content-wrapper">
                                            <div class="widget-content-left mr-3">
                                                <div class="widget-content-left">
                                                    <img width="40" class="rounded-circle"
                                                        src="assets/images/avatars/1.jpg" alt="">
                                                </div>
                                            </div>
                                            <div class="widget-content-left flex2">
                                                <div class="widget-heading">Vinnie Wagstaff</div>
                                                <div class="widget-subheading opacity-7">UI Designer</div>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td class="text-center">Amsterdam</td>
                                <td class="text-center">
                                    <div class="badge badge-info">On Hold</div>
                                </td>
                                <td class="text-center">
                                    <button type="button" id="PopoverCustomT-4"
                                        class="btn btn-primary btn-sm">Details</button>
                                </td>
                            </tr> -->
                        </tbody>
                    </table>
                </div>
            </div>

        </div>
    </div>
</div>

<div class="row" *ngIf="cmd?.appel_client?.length>0">
    <div class="col-md-8">
        <div class="main-card mb-3 card">
            <div class="card-header">Détail des appels de la commande
                "<strong>{{cmd.ref_facture_cmd}}</strong>"
                <div class="btn-actions-pane-right">
                    <div role="group" class="btn-group-sm btn-group">
                        <button type="button" id="PopoverCustomT-1"
                            class="btn btn-danger btn-sm">{{cmd.appel_client.length}}</button>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <div class="table-responsive">
                    <table class="align-middle mb-0 table table-borderless table-striped table-hover">
                        <thead>
                            <tr>
                                <th>Indice</th>
                                <th>Transporteur</th>
                                <th>Date de l'appel</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let appel of cmd.appel_client, let index = index">
                                <td>
                                    {{index+1}}
                                </td>
                                <td class="font-weight-600">Par
                                    {{appel.transporter_id?.nom_prenom_tracking}}</td>
                                <td>{{appel.date_accept | date:'MMM d, y h:mm:ss a'}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

        </div>
    </div>
</div>